module.exports = __webpack_public_path__ + "img/banner2.89fd8888.png";